import React, { useState } from "react";
import Spinner from "../../reusables/spinner";
import Dropdown from "../../reusables/dropdown";
import { connect } from "react-redux";
import {
  update_customer_licence,
  update_supplier_licence,
} from "../../../redux/actions/adminActions";
import InputField from "../../reusables/input";

function LicenseCapture({
  user,
  Currentcustomer,
  supplier,
  updateSupplierLicense,
  customer,
  newUser,
  prev,
  unapproved,
  next,
  submit,
  accessToken,
  updateCustomerLicense,
  close,
}) {
  const [prevData, setPrevData] = useState(user || null);

  const [supplierLicense, setLicense] = useState(
    !newUser
      ? {
          divers_licence: supplier?.divers_licence,
          photograph: supplier?.photograph,
          sent_drivers_licence: null,
          sent_photograph: null,
        }
      : null
  );
  const [formData, setData] = useState(
    !newUser
      ? {
          id_upload: Currentcustomer?.id_upload,
          proof_of_address: Currentcustomer?.proof_of_address,
          id_type: Currentcustomer?.id_type,
          id_number: Currentcustomer?.id_number,
          sent_id_upload: null,
          sent_proof: null,
        }
      : null
  );

  const [isLoading, setIsLoading] = useState(false);

  const handleLoading = () => {
    setIsLoading(true);

    setInterval(() => {
      setIsLoading(false);
    }, 4000);
  };

  const handleImageChange = (e) => {
    let reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);

    reader.onloadend = () => {
      if (customer) {
        if (e.target.name === "id_upload") {
          setData({
            ...formData,
            id_upload: reader.result,
            sent_id_upload: e.target.files[0],
          });
        } else {
          setData({
            ...formData,
            sent_proof: e.target.files[0],
            proof_of_address: reader.result,
          });
        }
      } else {
        if (e.target.name === "divers_licence") {
          setLicense({
            ...supplierLicense,
            divers_licence: reader.result,
            sent_drivers_licence: e.target.files[0],
          });
        } else {
          setLicense({
            ...supplierLicense,
            photograph: reader.result,
            sent_photograph: e.target.files[0],
          });
        }
      }
    };
  };

  const handleChange = (e) => {
    setData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (newUser) {
      submit(formData);
      next();
    } else {
      let formdata = new FormData();

      formdata.append("id_upload", formData.sent_id_upload);
      formdata.append("proof_of_address", formData.sent_proof);
      formdata.append("id_type", formData.id_type);
      formdata.append("id_number", formData.id_number);

      updateCustomerLicense(user?.id, formdata, formData, accessToken);
    }
  };

  const handleSupplierSubmit = (e) => {
    e.preventDefault();
    handleLoading();

    if (newUser) {
      setLicense({
        ...supplierLicense,
        divers_licence: supplierLicense.sent_drivers_licence,
        photograph: supplierLicense.sent_photograph,
      });
      submit(supplierLicense);
      next();
    } else {
      let formdata = new FormData();

      formdata.append("divers_licence", supplierLicense.sent_drivers_licence);
      formdata.append("photograph", supplierLicense.sent_photograph);

      updateSupplierLicense(
        user.id,
        formdata,
        unapproved ? "unapproved" : "approved",
        accessToken,
        close
      );
    }
  };

  return (
    <div className="sectionHeight--mid container">
      {customer ? (
        <div className="pb-2">
          <form className="py-3 px-2" onSubmit={handleSubmit}>
            {formData?.id_upload == null ? (
              <div>
                <p className="sectionText--small mt-2 mb-2">
                  Upload a valid ID
                </p>
                <div className="fileUpload center">
                  <input
                    type="file"
                    name="id_upload"
                    onChange={handleImageChange}
                  />
                  <p className="mb-0 sectionText--small textIsGreen  textIsBold">
                    Tap to upload
                  </p>
                </div>
              </div>
            ) : (
              <div className="sectionHeight--short hasBorder hasRadius p-2 fileHolder isRelative">
                <div className="alignOnly">
                  <div className="hasRadius bgGray imgHolder">
                    <img src={formData?.id_upload} className="w-100" alt="" />
                  </div>
                  <h2 className="sectionText--mid mx-3">A valid ID</h2>
                </div>

                <div className="fileOptions sectionText">
                  <span className="px-2 hasBorder--right isClickable">
                    <input
                      type="file"
                      style={{
                        width: "fit-content",
                      }}
                      name="id_upload"
                      onChange={handleImageChange}
                    />
                    Change
                  </span>
                  <span
                    className="px-2 isClickable"
                    onClick={() =>
                      setData({
                        ...formData,
                        id_upload: null,
                      })
                    }
                  >
                    Remove
                  </span>
                </div>
              </div>
            )}

            {formData?.proof_of_address == null ? (
              <div className="mt-3">
                <p className="sectionText--small mb-2 mt-2">
                  Proof of Residence
                </p>
                <div className="fileUpload center">
                  <input
                    type="file"
                    name="proof_of_address"
                    onChange={handleImageChange}
                  />
                  <p className="mb-0 sectionText--small textIsGreen  textIsBold">
                    Tap to upload
                  </p>
                </div>
              </div>
            ) : (
              <div className="sectionHeight--short hasBorder hasRadius p-2 fileHolder isRelative mt-3">
                <div className="alignOnly">
                  <div className="hasRadius bgGray imgHolder">
                    <img
                      src={formData?.proof_of_address}
                      className="w-100"
                      alt=""
                    />
                  </div>
                  <h2 className="sectionText--mid mx-3">Proof of Residence</h2>
                </div>

                <div className="fileOptions sectionText">
                  <span className="px-2 hasBorder--right isClickable">
                    <input
                      type="file"
                      style={{
                        width: "fit-content",
                      }}
                      name="proof_of_address"
                      onChange={handleImageChange}
                    />
                    Change
                  </span>
                  <span
                    className="px-2 isClickable"
                    onClick={() =>
                      setPrevData({
                        ...prevData,
                        proof_of_address: null,
                      })
                    }
                  >
                    Remove
                  </span>
                </div>
              </div>
            )}

            {!newUser && (
              <>
                <div className="py-3">
                  <p className="sectionText--small mb-1">ID Type</p>
                  <Dropdown long value={formData?.id_type}></Dropdown>
                </div>

                <div className="pb-2">
                  <InputField
                    label="ID Number"
                    name="id_number"
                    value={formData?.id_number}
                    onChange={handleChange}
                  />
                </div>
              </>
            )}

            <div className="py-3">
              {newUser ? (
                <button
                  className="btn__filled textIsBold"
                  onClick={handleSubmit}
                >
                  Continue
                </button>
              ) : isLoading ? (
                <button className="btn__filled textIsBold alignOnly" disabled>
                  Please Wait <Spinner />
                </button>
              ) : (
                <button
                  className="btn__filled textIsBold"
                  onClick={handleSubmit}
                >
                  Save Changes
                </button>
              )}
            </div>
          </form>
        </div>
      ) : (
        <div className="pb-2">
          <form className="py-2" onSubmit={handleSupplierSubmit}>
            {supplierLicense?.divers_licence == null ? (
              <div>
                <p className="sectionText--small mt-2 mb-2">
                  Upload Driver’s Licence
                </p>
                <div className="fileUpload center">
                  <input
                    type="file"
                    name="divers_licence"
                    onChange={handleImageChange}
                  />
                  <p className="mb-0 sectionText--small textIsGreen  textIsBold">
                    Tap to upload
                  </p>
                </div>
              </div>
            ) : (
              <div className="sectionHeight--short hasBorder hasRadius p-2 fileHolder isRelative">
                <div className="alignOnly">
                  <div className="hasRadius bgGray imgHolder">
                    <img
                      src={supplierLicense?.divers_licence}
                      className="w-100"
                      alt=""
                    />
                  </div>
                  <h2 className="sectionText--mid mx-3">Driver's License</h2>
                </div>

                <div className="fileOptions sectionText">
                  <span className="px-2 hasBorder--right isClickable">
                    <input
                      type="file"
                      style={{
                        width: "fit-content",
                      }}
                      name="divers_licence"
                      onChange={handleImageChange}
                    />
                    Change
                  </span>
                  <span
                    className="px-2 isClickable"
                    onClick={() =>
                      setLicense({
                        ...supplierLicense,
                        divers_licence: null,
                      })
                    }
                  >
                    Remove
                  </span>
                </div>
              </div>
            )}

            {supplierLicense?.photograph == null ? (
              <div className="mt-3">
                <p className="sectionText--small mb-2 mt-2">
                  Upload a Photograph
                </p>
                <div className="fileUpload center">
                  <input
                    type="file"
                    name="photograph"
                    onChange={handleImageChange}
                  />
                  <p className="mb-0 sectionText--small textIsGreen  textIsBold">
                    Tap to upload
                  </p>
                </div>
              </div>
            ) : (
              <div className="sectionHeight--short hasBorder hasRadius p-2 fileHolder isRelative mt-3">
                <div className="alignOnly">
                  <div className="hasRadius bgGray imgHolder">
                    <img
                      src={supplierLicense?.photograph}
                      className="w-100"
                      alt=""
                    />
                  </div>
                  <h2 className="sectionText--mid mx-3">Photograph</h2>
                </div>

                <div className="fileOptions sectionText">
                  <span className="px-2 hasBorder--right isClickable">
                    <input
                      type="file"
                      style={{
                        width: "fit-content",
                      }}
                      name="photograph"
                      onChange={handleImageChange}
                    />
                    Change
                  </span>
                  <span
                    className="px-2 isClickable"
                    onClick={() =>
                      setLicense({
                        ...supplierLicense,
                        photograph: null,
                      })
                    }
                  >
                    Remove
                  </span>
                </div>
              </div>
            )}

            <div className="py-3">
              {newUser ? (
                <button className="btn__filled textIsBold">Continue</button>
              ) : isLoading ? (
                <button className="btn__filled textIsBold alignOnly" disabled>
                  Please Wait <Spinner />
                </button>
              ) : (
                <button
                  className="btn__filled textIsBold"
                  onClick={handleSupplierSubmit}
                >
                  Save Changes
                </button>
              )}
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  accessToken: state.admin.token,
  supplier: state.admin.supplier,
  Currentcustomer: state.admin.customer,
});

const mapDispatchToProps = (dispatch) => ({
  updateSupplierLicense: (id, data, status, token, success) =>
    dispatch(update_supplier_licence(id, data, status, token, success)),
  updateCustomerLicense: (id, data, updatedLicence, token) =>
    dispatch(update_customer_licence(id, data, updatedLicence, token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LicenseCapture);
